import { WatchStopHandle, computed, ref, watch } from "vue";
import { currentSpeakers } from "./currentSpeakers";
import { roomState } from "./room";
import { authState } from "./auth";
import { getUserById } from "./usersState";

let lastSpeaker = "";
let watcher: WatchStopHandle | null = null;
let available = true;

const currentSpeaker = computed(() => {
  let speaker = currentSpeakers[0] || lastSpeaker || roomState.leader;
  if(speaker === authState.id) {
    speaker = lastSpeaker
  }
  if(speaker === authState.id) {
    speaker = roomState.leader
  }
  if (speaker && getUserById(speaker)) {
    return speaker;
  } else {
    return authState.id;
  }
});

export const activeSpeakerId = ref("");

const throttled = async (next: string) => {
  if (next && next !== activeSpeakerId.value) {
    if (!available) return;
    available = false;
    activeSpeakerId.value = next;
    lastSpeaker = next;
    setTimeout(() => {
      available = true;
      if (lastspeaked !== activeSpeakerId.value) {
        throttled(lastspeaked);
      }
    }, 5000);
  }
};

let lastspeaked = "";

export async function startSpeakerMode() {
  watcher = watch(
    () => currentSpeaker.value,
    (next) => {
      lastspeaked = next;
      throttled(next);
    },
    { immediate: true },
  );
}

export function endSpeakerMode() {
  if (watcher) {
    watcher();
    watcher = null;
  }
  lastSpeaker = "";
}
